/**
 * The time as a phone's clock face shows it: digits only. The locale still
 * decides 12 or 24 hour; the AM/PM marker is dropped, since at clock-face
 * sizes it wraps onto a second line and no phone shows it there anyway.
 */
export function clockFace(date: Date = new Date()): string {
  try {
    return new Intl.DateTimeFormat([], { hour: '2-digit', minute: '2-digit' })
      .formatToParts(date)
      .filter((part) => part.type !== 'dayPeriod')
      .map((part) => part.value)
      .join('')
      .trim();
  } catch {
    return date.toTimeString().slice(0, 5);
  }
}
